import "./UserRole.scss";

function UserRole() {
  return (
    <section className="crm-user-role">
      <header className="crm-user-role__header">
        <h1 className="crm-user-role__title">Benutzer &amp; Rollen</h1>
        <p className="crm-user-role__subtitle">
          Rollen &amp; Rechte werden serverseitig geführt (Core). Anzeige nur.
        </p>
      </header>

      <div className="crm-user-role__card">
        <span className="crm-user-role__avatar" aria-hidden="true">MK</span>
        <div className="crm-user-role__details">
          <span className="crm-user-role__name">Max Keller</span>
          <span className="crm-user-role__department">Vertrieb</span>
        </div>
        <span className="crm-user-role__status">Aktiv</span>
      </div>
    </section>
  );
}

export default UserRole;
